import React, { useState, useEffect, useContext } from "react";
import { Button } from "antd";
import {
	ArrowRightOutlined,
	CheckSquareOutlined,
	EditFilled,
	MinusSquareOutlined,
} from "@ant-design/icons";
import { WplywContext } from "../../../../context/wplywContext";
import StageData from "../Stages/Stage1/StageData";
import useStage1 from "../StagesChecker/stage1";
import useStage2 from "../StagesChecker/stage2";
import HeaderInfo from "./HeaderInfo";
import CancelButton from "./CancelButton";
import StagePersons from "../Stages/Stage2/StagePersons";
import StageForPerson from "../Stages/Stage3/StageForPerson";
import SaveButton from "./SaveButton";
import LogsDrawer from "./LogsDrawer";
import ConfirmButton from "./Confirm";
import { useActiveTab } from "../../../../context/activeTabContext";
import { ConfirmStatusManual } from "./Confirm/ConfirmStatus";
import { useAuth } from "../../../../context/AuthContext";
import isCan from "../../../../components/isCan";
import { Tooltip, Modal } from "antd";
import GenerateWplywRaport from "./GenerateWplywRaport";
import ArchiveButton from "./ArchiveButton";
import { useLocation } from "react-router";

const getPersonIdFromHash = (location) => {
	const search =
		location.search ||
		(window.location.hash.split("?")[1]
			? `?${window.location.hash.split("?")[1]}`
			: "");
	return new URLSearchParams(search).get("personid");
};

const MainStages = () => {
	const { wplyw, setWplyw } = useContext(WplywContext);
	const { activeTabX, setActiveTab } = useActiveTab();
	const { user } = useAuth();
	const location = useLocation();
	const perms = user.perms;
	const [cando, setCando] = useState(false); // Stan dla uprawnień
	const [isModalOpen, setIsModalOpen] = useState(false); // State for the confirmation modal
	const [pendingAction, setPendingAction] = useState(null);
	const personid = getPersonIdFromHash(location);
	const [candoWplywy, setCandoWplywy] = useState(false); // Stan dla uprawnień
	const [candoPersons, setCandoPersons] = useState(false); // Stan dla uprawnień
	const [candoKwoty, setCandoKwoty] = useState(false); // Stan dla uprawnień
	const [candoRachunki, setCandoRachunki] = useState(false); // Stan dla uprawnień
	const [permissionsLoaded, setPermissionsLoaded] = useState(false);

	const checkPermissions = async (
		requiredPerms,
		perms,
		setPermissionState,
	) => {
		const result = await isCan(requiredPerms, perms);
		setPermissionState(result); // Update state after fetching permissions
	};

	// Użycie useEffect do ustawiania wymaganych uprawnień
	useEffect(() => {
		const fetchPermissions = async () => {
			let requiredPerms = [];
			if (activeTabX.activeKey == "1") {
				requiredPerms = ["can_edit_dane_wplywu"];
			} else if (activeTabX.activeKey == "2") {
				requiredPerms = ["can_edit_persons"];
			} else if (
				activeTabX.activeKey == "3" &&
				activeTabX.innerActiveKey == "1"
			) {
				requiredPerms = ["can_edit_kwoty"];
			} else if (
				activeTabX.activeKey == "3" &&
				activeTabX.innerActiveKey == "2"
			) {
				requiredPerms = ["can_edit_rachunki"];
			}
			// Dodaj inne warunki, jeśli potrzebne
			const result = await isCan(requiredPerms, perms);
			setCando(result);
		};
		fetchPermissions();
	}, [activeTabX, perms]);

	useEffect(() => {
		const fetchPermissions = async () => {
			try {
				await Promise.all([
					checkPermissions(
						["can_preview_dane_wplywu"],
						perms,
						setCandoWplywy,
					),
					checkPermissions(
						["can_preview_persons"],
						perms,
						setCandoPersons,
					),
					checkPermissions(
						["can_preview_kwoty"],
						perms,
						setCandoKwoty,
					),
					checkPermissions(
						["can_preview_rachunki"],
						perms,
						setCandoRachunki,
					),
				]);
				setPermissionsLoaded(true); // Only set to true after all permissions are fetched
			} catch (error) {
				console.error("Error fetching permissions:", error);
				setPermissionsLoaded(true); // Optional: handle error state
			}
		};

		fetchPermissions();
	}, [perms]);

	// Load the active key from localStorage or default to "1"
	const [activeKey, setActiveKey] = useState(() => {
		if (personid) {
			return "3";
		}
		return localStorage.getItem("activeTabKey") || "1";
	});

	// Dynamically check if stages should be blocked
	const isStage1Blocked = !useStage1();
	const isStage2Blocked = useStage2();

	const tabsState = [
		{
			key: "1",
			title: "Dane wpływu",
			isBlocked:
				!candoWplywy ||
				wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_archived,
			isCompleted: !isStage1Blocked,
			isConfirmed: ConfirmStatusManual({
				activeKey: 1,
				innerActiveKey: 0,
				personid: null,
			}),
			component: <StageData />,
		},
		{
			key: "2",
			title: "Osoby",
			isBlocked:
				isStage1Blocked ||
				!candoPersons ||
				wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_archived,
			isCompleted:
				isStage2Blocked == "warning" || isStage2Blocked == "success",
			isConfirmed: isStage2Blocked == "success",
			component: <StagePersons />,
		},
		{
			key: "3",
			title: "Kwoty i rachunki",
			isHidden: true,
			isBlocked:
				useStage2() == "error" ||
				isStage1Blocked ||
				(candoRachunki == null && candoKwoty == null) ||
				wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_archived,
			isCompleted: false,
			isConfirmed: false,
			component: <StageForPerson />,
		},
	];

	useEffect(() => {
		console.log(isStage2Blocked);
	});

	useEffect(() => {
		if (activeTabX.activeKey == 3 && permissionsLoaded) {
			if (
				isStage2Blocked == "error" ||
				isStage1Blocked ||
				(!candoKwoty && !candoRachunki)
			) {
				setActiveKey(2);
			}
		}
		if (activeTabX.activeKey == 2 && permissionsLoaded) {
			if (isStage1Blocked || !candoPersons) {
				setActiveKey(1);
			}
		}
	}, [activeTabX, permissionsLoaded]);

	const handleEditToggle = () => {
		if (wplyw.changes.length > 0) {
			// Show the modal if there are unsaved changes
			setIsModalOpen(true);
			setPendingAction(() => () => {
				setWplyw({ ...wplyw, mode: "preview", reload: !wplyw.reload });
			});
		} else {
			// Directly toggle if no changes are present
			setWplyw({ ...wplyw, mode: "preview", reload: !wplyw.reload });
		}
	};

	const handleModalConfirm = () => {
		if (pendingAction) {
			pendingAction(); // Execute the stored action
			setPendingAction(null);
		}
		setIsModalOpen(false);
	};

	const handleModalCancel = () => {
		setPendingAction(null);
		setIsModalOpen(false);
	};

	// Update localStorage whenever activeKey changes
	useEffect(() => {
		localStorage.setItem("activeTabKey", activeKey);
		if (activeKey != 3 && (!personid || personid === null)) {
			setActiveTab({
				...activeTabX,
				activeKey: activeKey,
				innerActiveKey: null,
				personid: null,
			});
		}
	}, [activeKey]);

	// Reset activeKey when the wplyw ID changes
	useEffect(() => {
		if (personid) {
			setActiveKey("3");
			return;
		}

		if (
			wplyw?.wplyw_data?.data?.msr_wplywy?.msr_wplywy_own_id &&
			wplyw?.wplyw_data?.data?.msr_wplywy?.msr_wplywy_own_id !=
				localStorage.getItem("msrlastwplyw")
		) {
			setActiveKey("1"); // Reset to the first tab
			localStorage.setItem("activeTabKey", "1"); // Update localStorage
		}
		localStorage.setItem(
			"msrlastwplyw",
			wplyw?.wplyw_data?.data?.msr_wplywy?.msr_wplywy_own_id,
		); // Update localStorage
	}, [personid, wplyw?.wplyw_data?.data?.msr_wplywy?.msr_wplywy_own_id]);

	const handleTabChange = (key) => {
		const selectedTab = tabsState.find((tab) => tab.key === key);
		if (selectedTab?.isBlocked) {
			return;
		}
		setActiveKey(key);
	};

	const getIcon = (isCompleted, isBlocked) => {
		if (isCompleted)
			return (
				<CheckSquareOutlined
					style={{
						color: "#BD8136",
						fontSize: "20px",
						opacity: isBlocked ? "0.25" : "1",
					}}
				/>
			);
		return (
			<MinusSquareOutlined
				style={{
					color: "#BD8136",
					fontSize: "20px",
					opacity: isBlocked ? "0.25" : "1",
				}}
			/>
		);
	};

	return (
		<div className="main-stages">
			<Modal
				title="Masz niezapisane zmiany"
				visible={isModalOpen}
				onOk={handleModalConfirm}
				onCancel={handleModalCancel}
			>
				<p>
					Czy na pewno chcesz wyłączyć edycję? Niezapisane zmiany
					przepadną.
				</p>
			</Modal>
			{/* Tab Navigation */}
			<div style={{ display: "flex", gap: "0" }}>
				{tabsState.map((tab) => (
					<div
						key={tab.key}
						onClick={() => handleTabChange(tab.key)}
						style={{
							cursor: tab.isBlocked ? "not-allowed" : "pointer",
							padding: "10px 10px",
							borderRadius: "0",
							backgroundColor:
								activeKey == tab.key
									? tab.isConfirmed
										? "rgb(82, 196, 26)"
										: "#f5f5f5"
									: tab.isConfirmed
										? "rgb(82, 196, 26)"
										: "white",
							border:
								activeKey == tab.key
									? "2px solid #bd8136"
									: "1px solid #d9d9d9",
							opacity: tab.isBlocked ? "0.5" : "1",
							display: "flex",
							alignItems: "center",
							width: "100%",
							gap: "10px",
							color: tab.isConfirmed ? "white" : "black",
						}}
					>
						{!tab.isHidden ? (
							<div
								style={{
									background: tab.isCompleted
										? "rgb(82, 196, 26)"
										: "red",
									height: "25px",
									width: "25px",
									borderRadius: "5px",
									border: tab.isCompleted
										? "2px solid rgb(82, 196, 26)"
										: "2px solid #d9d9d9",
								}}
							></div>
						) : (
							<></>
						)}
						<span>
							{tab.title}
							{tab.isConfirmed ? " - Zatwierdzono" : ""}
						</span>
					</div>
				))}
			</div>

			{/* Content Section */}
			<div
				style={{
					padding: "20px",
					paddingTop: 0,
					borderRadius: "5px",
					width: "100%",
				}}
				className={wplyw.mode === "preview" ? "disabled" : ""}
			>
				{/* Header Section */}
				<div
					style={{
						position: "sticky",
						top: 0,
						textAlign: "center",
						padding: "10px 0",
						marginBottom: "20px",
						display: "flex",
						background: "white",
						zIndex: 100,
						gap: "20px",
						width: "100%",
						alignItems: "center",
						justifyContent: "space-between",
						borderBottom: "1px solid rgba(0,0,0,0.2)",
						paddingBottom: "20px",
					}}
				>
					<HeaderInfo />
					<div
						style={{
							display: "flex",
							gap: "10px",
							alignItems: "center",
						}}
					>
						<ArchiveButton />
						<CancelButton />
						<LogsDrawer></LogsDrawer>
						{!wplyw.wplyw_data.data.msr_wplywy
							.msr_wplywy_archived &&
							(wplyw.mode === "preview" ? (
								<Button
									onClick={() =>
										setWplyw({ ...wplyw, mode: "edit" })
									}
									type="primary"
									icon={<EditFilled />}
								>
									Edytuj
								</Button>
							) : (
								<>
									{activeTabX.activeKey == "3" &&
										activeTabX.innerActiveKey == "3" && (
											<GenerateWplywRaport
												wplywid={wplyw.msr_wplywy_id}
												wplywownid={
													wplyw?.wplyw_data?.data
														?.msr_wplywy
														?.msr_wplywy_own_id
												}
											></GenerateWplywRaport>
										)}
									<Button onClick={handleEditToggle}>
										Wyłącz edycje
									</Button>
									<div
										style={{
											display: "flex",
											gap: "10px",
											padding: "10px 10px",
											background: "#f1f1f1",
											border: "1px solid black",
										}}
									>
										<Tooltip title="Kliknij, aby wyłączyć tryb edycji. Niezapisane zmiany przepadną."></Tooltip>
										<SaveButton></SaveButton>
										<ConfirmButton
											activeKey={activeKey}
										></ConfirmButton>
									</div>
								</>
							))}
					</div>
				</div>

				{/* Active Tab Content */}
				<div>
					{tabsState.find((tab) => tab.key == activeKey)?.component}
				</div>
			</div>
		</div>
	);
};

export default MainStages;
